/**
 * VoyageSummaryCard.js
 *
 * Summary card for the Voyage sidebar.
 * Matches MaintenanceSummaryCard and DrillsSummaryCard pattern exactly.
 */

import React from 'react';
import { Ship, Anchor, MapPin } from 'lucide-react';
import { portLabel } from '../../../../utils/voyage/portLabel';

const VoyageSummaryCard = ({ stats, activeVoyage }) => {
  const totalVoyages = stats?.totalVoyages || 0;
  const thisMonth = stats?.voyagesThisMonth || 0;
  const totalHours = stats?.totalHoursThisMonth || 0;

  return (
    <div className="rounded-2xl border border-gray-200 shadow-sm bg-white overflow-hidden">
      {/* Header - DARK like Maintenance/Drills */}
      <div className="bg-slate-700 px-5 py-3">
        <div className="flex items-center gap-2">
          <Ship className="h-5 w-5 text-white" />
          <h3 className="text-base font-semibold text-white">Voyage Summary</h3>
        </div>
      </div>

      <div className="px-6 py-5">
        {/* Active Voyage Indicator (if underway) */}
        {activeVoyage && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center gap-2 text-green-700">
              <Anchor className="h-4 w-4" />
              <span className="font-medium text-sm">Voyage in Progress</span>
            </div>
            <div className="mt-1 text-sm text-green-600 flex items-center gap-1">
              <MapPin className="h-3 w-3" />
              {portLabel(activeVoyage.from, '')} → {portLabel(activeVoyage.to, '')}
            </div>
          </div>
        )}

        {/* Stats - Row format like Maintenance/Drills */}
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Total Voyages</span>
            <span className="text-sm font-semibold text-gray-900">{totalVoyages}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">This Month</span>
            <span className="text-sm font-semibold text-cyan-600">{thisMonth}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600">Total Hours</span>
            <span className="text-sm font-semibold text-gray-900">{totalHours}h</span>
          </div>
        </div>

        {/* Last Voyage */}
        {stats?.lastVoyage && (
          <div className="mt-4 pt-4 border-t border-gray-200">
            <div className="text-xs text-gray-500 mb-1">Last Voyage</div>
            <div className="text-sm font-medium text-gray-900">
              {portLabel(stats.lastVoyage.from)} → {portLabel(stats.lastVoyage.to)}
            </div>
            <div className="text-xs text-gray-500">{stats.lastVoyage.date}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VoyageSummaryCard;
